"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactContextViewController = void 0;
const react_1 = __importStar(require("react"));
const immer_1 = __importDefault(require("immer"));
const ErrorBoundary_1 = require("../ErrorBoundary");
class ReactContextViewController {
    constructor(state, contextValue, defaultRenderer) {
        this.state = state;
        this.contextValue = contextValue;
        this.defaultRenderer = defaultRenderer;
        this.context = (0, react_1.createContext)(this.contextValue);
    }
    isFunctionUpdater(updater) {
        return typeof updater === 'function';
    }
    createElement(state) {
        var _a, _b;
        return (_b = (_a = this.defaultRenderer) === null || _a === void 0 ? void 0 : _a.call(this, Object.assign(Object.assign({}, state), { context: this.context }))) !== null && _b !== void 0 ? _b : null;
    }
    setState(state) {
        var _a;
        if (this.isFunctionUpdater(state)) {
            this.state = state(this.state);
        }
        else {
            this.state = state;
        }
        (_a = this.setReactState) === null || _a === void 0 ? void 0 : _a.call(this, this.state);
    }
    setContextValue(value) {
        var _a;
        if (this.isFunctionUpdater(value)) {
            this.contextValue = value(this.contextValue);
        }
        else {
            this.contextValue = value;
        }
        (_a = this.setReactContext) === null || _a === void 0 ? void 0 : _a.call(this, this.contextValue);
    }
    updateState(updater) {
        var _a;
        this.state = (0, immer_1.default)(this.state, (draftValue) => {
            updater(draftValue);
        });
        (_a = this.setReactState) === null || _a === void 0 ? void 0 : _a.call(this, this.state);
    }
    updateContextValue(updater) {
        var _a;
        this.contextValue = (0, immer_1.default)(this.contextValue, (draftValue) => {
            updater(draftValue);
        });
        (_a = this.setReactContext) === null || _a === void 0 ? void 0 : _a.call(this, this.contextValue);
    }
    getState() {
        return this.state;
    }
    getContextValue() {
        return this.contextValue;
    }
    render() {
        if (this.element) {
            return this.element;
        }
        const ViewController = () => {
            const setState = (0, react_1.useState)(this.state)[1];
            const setContextValue = (0, react_1.useState)(this.contextValue)[1];
            this.setReactState = setState;
            this.setReactContext = setContextValue;
            return react_1.default.createElement(this.context.Provider, { value: this.contextValue }, react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, null, this.createElement(this.state)));
        };
        ViewController['displayName'] = this.constructor.name || 'ViewController';
        this.element = react_1.default.createElement(ViewController, null, null);
        return this.element;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    replace(viewController) {
        // no-op
    }
}
exports.ReactContextViewController = ReactContextViewController;
//# sourceMappingURL=ReactContextViewController.js.map